import { create } from 'zustand';
import type { GettingStartedDTO, GettingStartedStep } from '@clanfire/shared';
import { userApi } from '@/api/endpoints';

/**
 * The welcome tour and the getting-started checklist. The server says what's
 * done when the app loads; steps done since then are ticked here as they happen.
 */
interface GettingStartedState extends GettingStartedDTO {
  hydrate: (state: GettingStartedDTO) => void;
  markStep: (step: GettingStartedStep) => void;
  finishTour: () => void;
  setChecklistHidden: (hidden: boolean) => void;
}

const EMPTY: GettingStartedDTO = {
  showTour: false,
  showChecklist: false,
  steps: { avatar: false, twoFactor: false, message: false, voice: false, friend: false, server: false },
};

export const useGettingStarted = create<GettingStartedState>((set, get) => ({
  ...EMPTY,
  hydrate: (state) => set(state),
  markStep: (step) => {
    if (!get().steps[step]) set((s) => ({ steps: { ...s.steps, [step]: true } }));
  },
  finishTour: () => {
    if (!get().showTour) return;
    set({ showTour: false });
    void userApi.gettingStarted({ tourSeen: true }).catch(() => undefined);
  },
  setChecklistHidden: (hidden) => {
    set({ showChecklist: !hidden });
    void userApi.gettingStarted({ checklistHidden: hidden }).catch(() => undefined);
  },
}));

export const resetGettingStarted = () => useGettingStarted.setState(EMPTY);
